module.exports = __webpack_public_path__ + "img/icon_web.4b09a558.svg";